<!--
  Сообщение об ошибке загрузки файлов в AttachmentUploader.

  Показывает понятную причину, почему форму нельзя сохранить, и исчезает
  вместе с файлом, у которого не прошла загрузка.
-->
<template>
  <div class="attachment-upload-error" role="alert">
    <AppIcon
      name="info"
      :size="16"
      class="attachment-upload-error__icon"
    />
    <div class="attachment-upload-error__content">
      <strong class="attachment-upload-error__title">
        Проблема с файлом
      </strong>
      <span class="attachment-upload-error__message">
        {{ message }}
      </span>
      <span class="attachment-upload-error__hint">
        Удалите файл с ошибкой и прикрепите его снова
      </span>
    </div>
  </div>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "AttachmentUploadError",
  components: {
    AppIcon,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.attachment-upload-error {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: 0 0 10px;
  padding: 10px 12px;
  border: 1px solid #fecaca;
  border-radius: 6px;
  background-color: #fef2f2;
  color: #991b1b;
}

.attachment-upload-error__icon {
  flex: 0 0 auto;
  margin-top: 1px;
}

.attachment-upload-error__content {
  display: grid;
  gap: 2px;
}

.attachment-upload-error__title {
  font-size: 13px;
  line-height: 1.25;
}

.attachment-upload-error__message {
  color: #7f1d1d;
  font-size: 12px;
  line-height: 1.35;
}

.attachment-upload-error__hint {
  color: #991b1b;
  font-size: 12px;
  line-height: 1.35;
}
</style>
